import React from 'react';

import {StreamBankLink} from "../../StreamBankLink";

export const CreateProjectActivityFeedItemDescription = props => <p>
    {props.Event.Activity.User.name} created a new Project <StreamBankLink
    Context={props.Event.ContextNodeDetails.link}>{props.CustomEventData ? props.CustomEventData.title : ""}</StreamBankLink>.
</p>;



